(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('airCrews', {
                parent: 'app',
                url: '/airCrew/list',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/airCrew/airCrews.html',
                        controller: 'airCrewsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function (tabService) {
                                return tabService.getTabOccupationCrew('airCrews')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }],
                            'airCrews': ['airCrewService','$stateParams', function (airCrewService,$stateParams) {
                                return airCrewService.getPageAirCrews($stateParams.page, $stateParams.size)
                            }],
                            'modelAirCrafts': ['modelAircraftService', function (modelAircraftService) {
                                return modelAircraftService.getModelAircrafts()
                            }]
                        }
                    }
                }
            })
            .state('airCrewNew', {
                parent: 'app',
                url: '/airCrew/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/airCrew/airCrewNew.html',
                        controller: 'airCrewNewCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function (tabService) {
                                return tabService.getTabOccupationCrew('airCrews')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew','structureSeatMap']);
                            }],
                            'modelAirCrafts': ['modelAircraftService', function (modelAircraftService) {
                                return modelAircraftService.getModelAircrafts()
                            }]
                        }
                    }
                }
            })
            .state('airCrewEdit', {
                parent: 'app',
                url: '/airCrew/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/airCrew/airCrewEdit.html',
                        controller: 'airCrewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function (tabService) {
                                return tabService.getTabOccupationCrew('airCrews')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew','structureSeatMap']);
                            }],
                            'airCrew': ['airCrewService', '$stateParams', function (airCrewService, $stateParams) {
                                return airCrewService.getAirCrewById($stateParams.id)
                            }],
                            'modelAirCrafts': ['modelAircraftService', function (modelAircraftService) {
                                return modelAircraftService.getModelAircrafts()
                            }],
                            'id': ['$stateParams', function ($stateParams) {
                                return $stateParams.id
                            }]
                        }
                    }
                }
            })
            .state('airCrewDelete', {
                parent: 'airCrews',
                url: '/airCrew/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/airCrew/airCrew/airCrewDelete.html',
                        controller: 'airCrewDeleteCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['dosage']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('airCrews', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

